export const pallette = {
  white: "#ffffff",
  gray25: "#fcfdfa",
  gray50: "#fafbf6",
  gray100: "#f6f7ed", // ivory
  gray200: "#e5e4db",
  gray300: "#d1cec6",
  gray400: "#c0bcb5",
  gray500: "#9e9892",
  gray600: "#695b59",
  gray700: "#443333", // old burgundy
  gray800: "#372929",
  gray900: "#291f1f",
  black: "#0e0a0a",

  primary: "#800c1b", //falu red
  primary25: "#faf9f6",
  primary50: "#f3f0eb",
  primary75: "#eadfd8",
  primary100: "#dec8c3",
  primary200: "#c79999",
  primary300: "#af6a6f",
  primary400: "#983b45",
  primary500: "#800c1b",
  primary600: "#690c18",
  primary700: "#520b14",
  primary800: "#3c0b11",
  primary900: "#250a0d",

  secondary: "#188068", //viridian green
  secondary50: "#e0ebe0",
  secondary100: "#cadfd2",
  secondary200: "#9dc7b8",
  secondary300: "#71b09d",
  secondary400: "#449883",
  secondary500: "#188068",
  secondary600: "#166855",
  secondary700: "#145142",
  secondary800: "#123930",
  secondary900: "#10221d",

  success: "#188068",
  info: "#023e8a",
  warning: "#eaae47", // sunray
  danger: "#f22936", // imperial red
  light: "#f6f7ed",
  dark: "#291f1f"
} as const;
